import { motion } from "framer-motion";
import { CheckCircle2Icon, RefreshCwIcon, ClockIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
const items = [{
  t: "Biblioteca Clínica del Sistema Maestro (6 Tomos Premium)",
  v: "$97 USD"
}, {
  t: "Sistema Visual de Decisión Clínica (SVDC)",
  v: "$67 USD"
}, {
  t: "Protocolos Clínicos Paso a Paso",
  v: "$47 USD"
}, {
  t: "Biblioteca de Casos y Recursos Visuales",
  v: "$49 USD"
}, {
  t: "5 Bonos Exclusivos",
  v: "$154 USD"
}];
export function Offer() {
  return <section id="oferta" className="w-full bg-[#0a1a34] py-14 sm:py-20" data-id="element-166" data-mp="13xawxfe2rp7r">
      <div className="mx-auto max-w-lg px-5 sm:max-w-2xl" data-id="element-167" data-mp="yxy2a8gypdum">
        <div className="mx-auto max-w-xl text-center" data-id="element-168" data-mp="ywd7qiunduwr">
          <span className="inline-block rounded-full bg-[#f5a623]/15 px-3 py-1 text-xs font-700 uppercase tracking-wider text-[#f5a623]" data-id="element-169" data-mp="2fboey3m5dafv">
            🏆 Oferta Especial de Lanzamiento
          </span>
          <h2 className="mt-3 font-head text-2xl font-800 text-white sm:text-3xl" data-id="element-170" data-mp="pkqpof5323ce">
            Esto es todo lo que recibirás hoy
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="mt-8 overflow-hidden rounded-3xl border border-white/10 bg-white shadow-2xl" data-id="element-171" data-mp="ulemxijwngf2">
          <div className="p-6 sm:p-8" data-id="element-172" data-mp="6rmqke93iyae">
            <ul className="space-y-3" data-id="element-173" data-mp="bsaq5obe4ng8">
              {items.map(it => <li key={it.t} className="flex items-start justify-between gap-3 border-b border-slate-100 pb-3" data-id="element-174" data-mp="fufj0ku0lg1t">
                  <span className="flex items-start gap-2 text-sm text-slate-700 sm:text-[15px]" data-id="element-175" data-mp="kmfcpvjhrcpy">
                    <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-[#1e88e5]" data-id="element-176" data-mp="3k8dnb04vmtqb" />
                    {it.t}
                  </span>
                  <span className="shrink-0 text-sm font-600 text-slate-400" data-id="element-177" data-mp="vfh548yeuvjv">
                    {it.v}
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 flex items-center justify-between rounded-xl bg-slate-100 px-4 py-3" data-id="element-178" data-mp="qetdpm69scp4">
              <span className="font-head text-sm font-800 uppercase tracking-wide text-slate-500" data-id="element-179" data-mp="106h0vavsn7ks">
                Valor Total
              </span>
              <span className="font-head text-xl font-800 text-slate-400 line-through" data-id="element-180" data-mp="cho276nselmh">
                $414 USD
              </span>
            </div>

            <div className="mt-6 text-center" data-id="element-181" data-mp="lhkxvs8lgkr1">
              <p className="text-sm font-600 text-slate-500" data-id="element-182" data-mp="lichs5stwu1h">
                Hoy puedes acceder por solo
              </p>
              <div className="mt-1 flex items-end justify-center gap-1" data-id="element-183" data-mp="heobdqfxo4ht">
                <span className="font-head text-5xl font-800 text-[#0f2547] sm:text-6xl" data-id="element-184" data-mp="1wvewswfa5bjj">
                  $12.99
                </span>
                <span className="mb-1.5 font-head text-lg font-800 text-[#0f2547]" data-id="element-185" data-mp="1sxh6trdoqlf3">
                  USD
                </span>
              </div>
              <p className="mt-1 text-xs font-500 text-slate-400" data-id="element-186" data-mp="25erza5jmajfm">
                Pago único • Acceso de por vida • Descarga inmediata
              </p>
            </div>

            {/* Scarcity */}
            <div className="mt-6" data-id="element-187" data-mp="1vglzbthdfnde">
              <ScarcityBar data-id="element-188" data-mp="1vhnarz2aubvn" />
            </div>

            {/* CTA */}
            <div className="mt-6" data-id="element-189" data-mp="2j6gbe8tv97wl">
              <CtaButton label="Quiero el Sistema Maestro ahora" data-id="element-190" data-mp="2j784nczzqtjp" />
            </div>

            {/* Countdown under CTA */}
            <div className="mt-5 rounded-xl bg-[#0f2547] px-4 py-4" data-id="element-191" data-mp="29fllmuhevq6e">
              <p className="mb-3 text-center text-xs font-700 uppercase tracking-wider text-white/60" data-id="element-192" data-mp="29d97kserxzym">
                <ClockIcon className="mr-1 inline h-3.5 w-3.5" data-id="element-193" data-mp="2ec2bbt49ecll" />
                La oferta termina en
              </p>
              <Countdown data-id="element-194" data-mp="36ug0737mao8j" />
            </div>

            <div className="mt-4 flex flex-col items-center gap-2 text-center" data-id="element-195" data-mp="36vhnq75tl375">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-[#1e88e5]/10 px-3 py-1.5 text-xs font-600 text-[#1e88e5]" data-id="element-196" data-mp="1j6o5ecsbh851">
                <RefreshCwIcon className="h-3.5 w-3.5" data-id="element-197" data-mp="1e9ea4gi8y29a" />
                El cambio de moneda se realiza automáticamente según tu país
              </span>
              <span className="text-xs text-slate-400" data-id="element-198" data-mp="149x766udq2h0">
                Acceso inmediato • Pago seguro • Garantía de 7 días
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}